export const generateExcel = (
  // TODO: this is the correct list type,
  //  list: (string | number | undefined)[][],
  list: any,
  title = "لیست تسویه‌ها",
  fileName = "PayPing-cashout.xlsx"
): void => {
  import(/* webpackPreload: true */ "xlsx").then(({ utils, writeFile }) => {
    const headerRow = Array.isArray(list?.[0]) ? list[0] : [];
    const dataRows = Array.isArray(list?.[1]) ? list[1] : [];
    const rows = [headerRow, ...dataRows].filter((row) => Array.isArray(row));

    if (!rows.length || rows[0].length === 0) return;

    const listWorksheet = utils.aoa_to_sheet(rows);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, listWorksheet, title);
    writeFile(workbook, fileName);
  });
};
